import type { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant } from '../../hook/__generated__/PricingPageShopProduct';

export enum LicenseCardVariant {
  Default = 'default',
  Recommendation = 'recommendation',
  Unqualified = 'unqualified',
}

export type LicenseCardProps = {
  variant?: LicenseCardVariant;
  productVariant: MagentoProductVariant;
  isSelected?: boolean;
  hasError?: boolean;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  sx?: Record<string, unknown>;
};
